import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';
import {recentData} from "../../redux.types";


export const recentDatas = createAction(types.RECENT_DATA, (recentData:recentData) => ({
    payload: recentData,
}));
